import { render, staticRenderFns } from "./IncidentsRangeChart.vue?vue&type=template&id=15bc043e&scoped=true"
import script from "./IncidentsRangeChart.vue?vue&type=script&lang=js"
export * from "./IncidentsRangeChart.vue?vue&type=script&lang=js"
import style0 from "./IncidentsRangeChart.vue?vue&type=style&index=0&id=15bc043e&prod&lang=scss&scoped=true"
import style1 from "./IncidentsRangeChart.vue?vue&type=style&index=1&id=15bc043e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc043e",
  null
  
)

export default component.exports